/** The loading screen (docs/ui-decisions.md): what's loading, the stage,
 *  and a progress bar, until the first frame is drawn. It's visible from
 *  the first paint when the page starts in a battle, replay or the atlas
 *  (`html.booting`, set by a script in the page's head). */

import { $ } from "./format";

export function showLoading(title: string, stage = ""): void {
  $("loading-title").textContent = title;
  setStage(stage, -1);
  $("loading").classList.remove("hidden");
}

/** The current stage; `progress` 0..1, or negative for unknown. */
export function setStage(stage: string, progress = -1): void {
  $("loading-stage").textContent = stage;
  const bar = $("loading-bar");
  bar.classList.toggle("indeterminate", progress < 0);
  (bar.firstElementChild as HTMLElement).style.width = progress < 0 ? "" : `${Math.round(progress * 100)}%`;
}

export function hideLoading(): void {
  $("loading").classList.add("hidden");
  document.documentElement.classList.remove("booting");
}

export function loadingShown(): boolean {
  return !$("loading").classList.contains("hidden") || document.documentElement.classList.contains("booting");
}
